import React from 'react';
import { ButtonVariant } from '@amzn/atoz-web/Button';
import { SpinnerColorScheme } from '@amzn/atoz-web/Spinner';
import { useTranslation } from 'react-i18next';
import { LoadingButton } from '../../../shared';
export var useSelectVtoModalButtons = function (_a) {
    var onClickAccept = _a.onClickSelect, acceptVtoIsSubmitting = _a.acceptVtoIsSubmitting;
    var t = useTranslation().t;
    return [
        React.createElement(LoadingButton, { onClick: onClickAccept, key: "shift_management_features_VtoAcceptModal_accept", ariaLabel: t('shift_management_features_VtoAcceptModal_accept'), altText: t('shift_management_common_button', {
                label: t('shift_management_features_VtoAcceptModal_accept')
            }), buttonVariant: ButtonVariant.Primary, spinnerColor: SpinnerColorScheme.Inverted, loading: acceptVtoIsSubmitting, dataTestId: "SelectVtoModalAcceptButton", buttonText: t('shift_management_features_VtoAcceptModal_accept') })
    ];
};
